import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'actions/modal';
import { MODAL_FORM } from 'constants/form';

const useResultSuccessLogic = ({
  mapperId,
  prospectId,
  showOtherTeachers,
  bestTeacher,
  otherTeachers,
  timezone,
  date,
}) => {
  const [isNotGoodMatch, setIsNotGoodMatch] = useState(false);
  const dispatch = useDispatch();
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const bestTeacherId = bestTeacher?.id;

  useEffect(() => {
    if (bestTeacherId && !showOtherTeachers) {
      setSelectedTeacher(bestTeacherId);
    } else if (showOtherTeachers && otherTeachers?.length === 1) {
      setSelectedTeacher(otherTeachers?.[0]?.id);
    } else {
      setSelectedTeacher(null);
    }
  }, []);

  const handleAssignTeacher = (selectedTeacher, dateTimePreset, filters) => {
    let teachersArray = [...otherTeachers];
    teachersArray.push(bestTeacher);
    const foundTeacher = teachersArray.find(teacher => teacher.id === selectedTeacher);
    const timezone = filters?.timezone || {};
    const date = dateTimePreset.length > 0 ? dateTimePreset[0].date : null;
    const inputTime = dateTimePreset.length > 0 ? dateTimePreset[0].time : null;
    dispatch(
      openModal(
        MODAL_FORM.AC_LED_MAPPING_BOOK_TRIAL_CLASS_MODAL,
        {
          size: 'custom',
          width: '542px',
        },
        {
          teacherName: foundTeacher?.name,
          teacherID: selectedTeacher,
          timezone,
          prospectID: prospectId,
          selectedDate: date,
          inputTime: inputTime,
        },
      ),
    );
  };
  const handleSelectTeacher = id => {
    setSelectedTeacher(id);
  };

  return {
    isNotGoodMatch,
    setIsNotGoodMatch,
    handleAssignTeacher,
    handleSelectTeacher,
    selectedTeacher,
  };
};

export default useResultSuccessLogic;
